<mat-drawer-container>
  <mat-drawer [mode]="drawerMode" [opened]="drawerOpened" #drawer>
    <!-- Mailbox sidebar -->
    <project-tenants-sidebar></project-tenants-sidebar>
  </mat-drawer>

  <mat-drawer-content>
    <!-- Main -->
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
